import {
  GRID_ROW_SELECTION,
  IFieldPreferences,
  IModalDialogOptions,
  IProcessedEvent,
  WIDGET_COMPONENT,
} from '@app/shared/types';
import { BTN_CANCEL, BTN_DONE } from '@app/text-content/button-templates';
import { MAX_PAGE_SIZE, WIDGET_FAMILY } from '@config/global-constants';
import { ICellRendererParams } from 'ag-grid-community';
import { filter, get, includes, isEmpty, merge, startCase } from 'lodash';

const eventSelectorModal = (
  events: { selectedEventIds: string[]; list: IProcessedEvent[] },
  filterType: string[],
  isSingle = GRID_ROW_SELECTION.SINGLE,
  field?: IFieldPreferences,
): IModalDialogOptions => {
  return merge(
    {},
    {
      title: 'Please Select an Event',
      validation: true,
      modalClass: `modal-lg ${isSingle === GRID_ROW_SELECTION.SINGLE ? 'hidden-header-checkbox' : ''} `,
      buttons: [
        {
          ...BTN_DONE,
          caption: 'Select Event',
          disabled: (value): boolean => isEmpty(value.events),
        },
        BTN_CANCEL,
      ],
      value: {
        events: events.selectedEventIds,
      },
      schema: {
        type: 'object',
        properties: {
          events: {
            type: 'array',
            maxItems: get(field, 'widgetData.maxItems', MAX_PAGE_SIZE),
            minItem: get(
              field,
              'widgetData.minItems',
              get(field, 'required') ? 1 : 0,
            ),
          },
        },
      },
      formRules: {
        fields: {
          events: {
            title: null,
            ignoreAutoTitleWhenTranslate: true,
            widgetFamily: WIDGET_FAMILY.XUX,
            widget: WIDGET_COMPONENT.grid_list,
            widgetData: {
              userGridOptions: {
                rowSelection: isSingle,
              },
              gridHeight: '270px',
              hideActionPanel: true,
              valueField: 'id',
              selectOptions: isEmpty(filterType)
                ? events.list
                : filter(events.list, (item) =>
                    includes(filterType, item.status),
                  ),
              columns: [
                {
                  title: 'Event Name',
                  path: 'name',
                  defaultView: true,
                  sortable: false,
                },
                {
                  title: 'Event Date',
                  path: 'date',
                  defaultView: true,
                },
                {
                  title: 'Event Type',
                  path: 'event_type_entity_name',
                  defaultView: true,
                },
                {
                  title: 'Status',
                  path: 'status',
                  defaultView: true,
                  cellRenderer: (record: ICellRendererParams): string =>
                    startCase(record?.value),
                },
              ],
            },
          },
        },
      },
    },
  );
};

export const eventSelectorModalDefinition = {
  eventSelectorModal,
};
